import { ValutProgressLoader } from "../ValutProgressOverlay/ValutProgressLoader";

export const BrandingBootstrapLoader = ({
  partner = false,
  error = null,
  onRetry,
}) => (
  <div
    className={`branding-bootstrap${partner ? " branding-bootstrap--partner" : ""}`}
    role="status"
    aria-live="polite"
    aria-busy={!error}
  >
    <div className="branding-bootstrap__backdrop" aria-hidden="true" />
    <div className="branding-bootstrap__content">
      {!error &&
        (partner ? (
          <div className="branding-bootstrap__spinner" aria-hidden="true" />
        ) : (
          <ValutProgressLoader />
        ))}
      <p className="branding-bootstrap__label">
        {error
          ? error
          : partner
            ? "Carregando experiência…"
            : "Carregando…"}
      </p>
      {error && typeof onRetry === "function" ? (
        <button
          type="button"
          className="branding-bootstrap__retry"
          onClick={onRetry}
        >
          Tentar novamente
        </button>
      ) : null}
    </div>
  </div>
);
